import React, { useEffect } from "react";
import { Box, Typography, CircularProgress, Divider } from "@mui/material";
import { useLazyGetShipmentLogsQuery } from "store/services/shipmentApi";
import moment from "moment";
import RecordCard from "./RecordCard";

const FieldRow = ({ label, value }) => (
    <Box sx={{ display: "flex", py: 0.25 }}>
        <Box sx={{ width: "40%", color: "text.primary", fontSize: "0.7rem", fontWeight: 600 }}>{label}</Box>
        <Box sx={{ width: "60%", fontSize: "0.74rem", fontWeight: 500, wordBreak: "break-word" }}>{value ?? "N/A"}</Box>
    </Box>
);

const ShipmentChangeLogsCompact = ({ shipmentId }) => {
    const [getShipmentLogs, { data: logsData, isLoading, isFetching, error }] = useLazyGetShipmentLogsQuery();

    useEffect(() => {
        if (shipmentId) getShipmentLogs(shipmentId);
    }, [shipmentId, getShipmentLogs]);

    if (isLoading || isFetching) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <CircularProgress size={18} />
            </Box>
        );
    }

    if (error) {
        return (
            <Typography sx={{ fontSize: "0.72rem", color: "error.main", p: 1 }}>
                {error?.data?.message || "Something went wrong"}
            </Typography>
        );
    }

    const changeLogs = logsData?.data?.details || [];

    if (!changeLogs.length) {
        return (
            <Typography sx={{ fontSize: "0.74rem", color: "text.secondary", textAlign: "center", py: 2 }}>
                No change logs found for this shipment.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 1 }}>
            {changeLogs.map((row, idx) => (
                <RecordCard key={row._id || idx}>
                    <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, textTransform: "capitalize", mb: 0.5 }}>
                        {row.field?.replace(/_/g, " ")}
                    </Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    <FieldRow label="Old Value" value={row.oldValue} />
                    <FieldRow label="New Value" value={row.newValue} />
                    <FieldRow label="Changed By" value={row.changedBy?.name || "Unknown"} />
                    <FieldRow label="Time" value={moment(row.createdAt).format("MMM D, YYYY HH:mm")} />
                </RecordCard>
            ))}
        </Box>
    );
};

export default ShipmentChangeLogsCompact;